// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_notify_error-module__container--A0YOx{text-align:right;margin-top:-20px;margin-bottom:25px}@media screen and (max-width: 62.5625em){.lawyer_notify_error-module__container--A0YOx{padding-right:10px}}.lawyer_notify_error-module__link--bzoMg{color:#616161;cursor:pointer}.lawyer_notify_error-module__link--bzoMg:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"container": "lawyer_notify_error-module__container--A0YOx",
	"link": "lawyer_notify_error-module__link--bzoMg"
};
module.exports = exports;
